<card name="Custom Controls">
  <div card content>
    <p>value checkbox: {{ group.get('check').value }}</p>
    <p>value radio: {{ group.get('radio').value }}</p>
    <form [formGroup]="group" (ngSubmit)="debug()">
      <div class="form-group">
        <div class="form-check">
          <check-input formControlName="check">Новый</check-input>
        </div>
      </div>

      <div class="form-group">
        <div class="form-check">
          <check-input name="radio" type="radio" value="Новый" formControlName="radio">Новый</check-input>
        </div>
        <div class="form-check">
          <check-input name="radio" type="radio" value="Старый" formControlName="radio">Старый</check-input>
        </div>
        <div class="form-check">
          <check-input name="radio" type="radio" value="Неизвестно" formControlName="radio">Неизвестно</check-input>
        </div>
      </div>

      <button>Submit</button>
    </form>
  </div>
</card>
